import { render } from "./EventSmsNotificationsView.vue?vue&type=template&id=1ea7466c&scoped=true"
import script from "./EventSmsNotificationsView.vue?vue&type=script&lang=js"
export * from "./EventSmsNotificationsView.vue?vue&type=script&lang=js"

import "./EventSmsNotificationsView.vue?vue&type=style&index=0&id=1ea7466c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ea7466c"]])

export default __exports__